import React from "react";

export const InfoCircleIcon = ({ width = "16", height = "16", color = "#188CE5" }) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5467_10227)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.00065 7.16658C8.27679 7.16658 8.50065 7.39044 8.50065 7.66658V10.9999C8.50065 11.2761 8.27679 11.4999 8.00065 11.4999C7.72451 11.4999 7.50065 11.2761 7.50065 10.9999V7.66658C7.50065 7.39044 7.72451 7.16658 8.00065 7.16658Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.3418 4.62753C8.54705 4.81226 8.56369 5.12841 8.37896 5.33366L8.3723 5.34107C8.18757 5.54632 7.87142 5.56296 7.66617 5.37823C7.46091 5.1935 7.44427 4.87736 7.629 4.6721L7.63567 4.66469C7.8204 4.45944 8.13654 4.4428 8.3418 4.62753Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.00065 1.83325C4.59489 1.83325 1.83398 4.59416 1.83398 7.99992C1.83398 11.4057 4.59489 14.1666 8.00065 14.1666C11.4064 14.1666 14.1673 11.4057 14.1673 7.99992C14.1673 4.59416 11.4064 1.83325 8.00065 1.83325ZM0.833984 7.99992C0.833984 4.04188 4.04261 0.833252 8.00065 0.833252C11.9587 0.833252 15.1673 4.04188 15.1673 7.99992C15.1673 11.958 11.9587 15.1666 8.00065 15.1666C4.04261 15.1666 0.833984 11.958 0.833984 7.99992Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5467_10227">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};


